module.exports = __webpack_public_path__ + "static/img/yzm.e3a484b.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/yzm.png
// module id = Rrq8
// module chunks = 1